export const upperFirst = (string) => {
  return string[0].toUpperCase() + string.slice(1)
}
export const maxLength = (string, cut) => {
  return string.slice(40)
}
export default { maxLength }
